import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Whisper } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { ButtonPrimary, ButtonSecondary, Layout, TableHeading } from '../../../../../components';
import { OPEN_WHOLESALE_MODAL } from '../../../../../reducers/PrecoAtacado/modals';
import {
  RESET_PRECO_ATACADO_SELECTED_DATAPOINTS,
  selectorPrecoAtacadoSelectedDatapoints,
  SET_PRECO_ATACADO_SELECTED_DATAPOINTS,
} from '../../../../../reducers/PrecoAtacado/selectedDatapoints';
import { selectorPrecoAtacadoTotalElements } from '../../../../../reducers/PrecoAtacado/totalElements';
import { LinkButton } from '../../../RevisaoPrecos/Components';
import { getTotalProducts, isEmptyFilters } from '../../../RevisaoPrecos/utils';
import { CLEAR_FIELDS_TOOLTIP } from '../../pages/PrecoAtacado/constants';
import styles from './PrecoAtacadoTableHeading.module.scss';

const { Container, TotalProducts } = TableHeading;

const PrecoAtacadoTableHeading = () => {
  const dispatch = useDispatch();

  const totalElements = useSelector(selectorPrecoAtacadoTotalElements);

  const filters = useSelector((state: RootState) => {
    return state.precoAtacadoReducer.filters.values;
  });

  const selectedDatapoints = useSelector(selectorPrecoAtacadoSelectedDatapoints);

  const { excludedIds, selectedAll, selectedIds } = selectedDatapoints;

  const currentList = useMemo(() => {
    return selectedAll ? excludedIds : selectedIds;
  }, [selectedDatapoints]);

  const isSelected = useMemo(() => currentList.length > 0 || selectedAll, [currentList, selectedAll]);

  const total = useMemo(() => getTotalProducts(totalElements, selectedDatapoints), [totalElements, selectedDatapoints]);

  const isFilterEmpty = useMemo(() => isEmptyFilters(filters), [filters]);

  const handleSelectAll = useCallback(() => {
    if (selectedAll) {
      dispatch(RESET_PRECO_ATACADO_SELECTED_DATAPOINTS());
      return;
    }

    dispatch(SET_PRECO_ATACADO_SELECTED_DATAPOINTS({ selectedAll: true, selectedIds: [], excludedIds: [] }));
  }, [dispatch, selectedAll]);

  const handleChangeMassivePrice = useCallback(() => {
    dispatch(OPEN_WHOLESALE_MODAL('CHANGE_MASSIVE_PRICE'));
  }, [dispatch]);

  const handleClearMassiveFields = useCallback(() => {
    dispatch(OPEN_WHOLESALE_MODAL('CLEAR_FIELDS'));
  }, [dispatch]);

  return (
    <Layout.Section>
      <TableHeading isSelected={isSelected}>
        <Container>
          <TotalProducts total={total} />
          {!isFilterEmpty && <LinkButton onClick={handleSelectAll}>{selectedAll ? 'Limpar seleção' : 'Selecionar tudo'}</LinkButton>}
        </Container>
        <Container>
          <Whisper trigger="hover" placement="bottom" speaker={<Tooltip className={styles.tooltip}>{CLEAR_FIELDS_TOOLTIP}</Tooltip>}>
            <span className={styles['clear-fields-wrapper']}>
              <ButtonSecondary
                className={styles['clear-fields-button']}
                theme="blue"
                onClick={handleClearMassiveFields}
                disabled={!isSelected}
                id="clear-massive-fields-btn"
              >
                Limpar campos
              </ButtonSecondary>
            </span>
          </Whisper>
          <ButtonPrimary onClick={handleChangeMassivePrice} disabled={!isSelected} id="change-massive-price-btn">
            Alterar
          </ButtonPrimary>
        </Container>
      </TableHeading>
    </Layout.Section>
  );
};

export default PrecoAtacadoTableHeading;
